export default {
  methods: {
    isValue(value) {
      //function that returns also with 0-value true
      return !(value === "" || value === null || value === undefined)
    },
    getObjectValueByPath(o, s) {
      if (!o || !s) return o
      //TODO use from vuetify or get from lodash
      s = s.replace(/\[(\w+)\]/g, ".$1") // convert indexes to properties
      s = s.replace(/^\./, "") // strip a leading dot
      let a = s.split(".")
      for (let i = 0, n = a.length; i < n; ++i) {
        let k = a[i]
        if (!o) return
        if (k in o) {
          o = o[k]
        } else {
          return
        }
      }
      return o
    },
    createItemValue(item, header) {
      return this.getObjectValueByPath(item, header.value)
    },
    createItemPathObject(item, header) {
      return this.getObjectValueByPath(item, header.path)
    },
    createItemProps(item, header, isMobile) {
      return {
        item,
        header,
        isMobile,
        value: this.createItemValue(item, header),
      }
    },
    getHeaders(obj){
      return (obj && Array.isArray(obj) ? obj : obj?.headers) || []
    },
    adaptModels(headers, items){
      //TODO improvable. Do everything in one and dont create a list fist that we loop
      //TODO improvable not calculate(dynamicModel) if the value already exists
      if(!headers) return items

      if(!Array.isArray(headers)){
        const {mobileView, headers:tableHeaders} = headers
        const {title, list, grid, expansion} = mobileView
        headers = [
          ...tableHeaders,
          ...this.getHeaders(title),
          ...this.getHeaders(list),
          ...this.getHeaders(grid),
        ]

        Object.values(expansion || {})
        .forEach( expHeaders => headers=[...headers, ...this.getHeaders(expHeaders)])
      }

      headers.forEach((header) => {
        if (header?.dynamicModel) {
          items = items.map((item) => ({
            ...item,
            [header.value]: header.dynamicModel(
              this.createItemPathObject(item, header)
            ),
          }))
        }
      })
      return items
    }
  }
}
